import React, { useState, useEffect, useRef } from "react"
import {
  getPsychologistDetails,
  saveAdditionalNotes,
  savePsychologyAssessment
} from "../../../../core/services/api/patientClinicalService"
import SummaryView from "../../../../components/SummaryView"
import ConsultantNotesView from "../../../../components/ConsultantNotesView"
import JSONRenderer from "../../../../components/JSONRenderer/JSONRenderer"
import Toast from "../../../../components/Toast"
import "./Psychologist.scss"
import { MocUserRole } from "../../../../core/services/models/Enums"
import Button from "components/Button/Button"
import { getTemplatesByType, getVitals } from "core/services/api/patientDiagnosisService"
import Print from "components/Print/Print"

const Psychologist: React.FunctionComponent<any> = (
  {
    patientInfo,
    recordDetails,
    appointmentDetails,
    isReadOnly,
    selectedIpdTab,
    staffType,
    smartSummaryDetails,
    fetchSmartSummary
  }
) => {

  const centerId = appointmentDetails?.centerId
  const consultantId = appointmentDetails?.consultantId
  const appointmentId = appointmentDetails?.id
  const recordId = recordDetails?.id
  const patientId = appointmentDetails?.patientId
  const componentRef = useRef()
  const tabSection: string[] = [
    "Smart Summary",
    "Assessment",
    "Progress",
    "Follow up visit",
  ]

  const [vitalsData, setVitalsData] = useState<any>()
  const [selectedTab, setSelectedTab] = useState("Smart Summary")
  const [psychologistAssessment, setPsychologistAssessment] = useState<any>({})
  const [psychologistAssessmentPrint, setPsychologistAssessmentPrint] = useState<any>({})
  const [assessmentData, setAssessmentData] = useState()
  const [psychologistData, setPsychologistData] = useState<any>()
  const [isCompleted, setIsCompleted] = useState<any>(false)
  const [resConsultantNoteData, setResConsultantNoteData] = useState<any>({})
  const [isConsultantNoteData, setIsConsultantNoteData] = useState(false)
  const [progressNotes, setProgressNotes] = useState<any>("")
  const [progressNotesSaved, setProgressNotesSaved] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    if (recordId) {
      getVitals(recordId)
        .then((res: any) => {
          setVitalsData(res?.data)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }, [])

  useEffect(() => {
    const completeBtn = document.getElementById("sv-nav-complete")
    if (isReadOnly && completeBtn) {
      completeBtn.style.display = "none"
    }
  })

  useEffect(() => {
    let tempJson: any, tempJsonPrint: any = {}
    getTemplatesByType("PSYCHOLOGIST")
      .then((res: any) => {
        //Assessment JSON
        tempJson = res?.find((e: any) => e?.subType === "Assessment")?.data[0]?.json || {}
        tempJsonPrint = res?.find((e: any) => e?.subType === "Assessment Print")?.data[0]?.json || {}
        setPsychologistAssessmentPrint(tempJsonPrint)
        //Read Only Check
        if (isReadOnly) {
          //Assessment
          tempJson["pages"][0]["readOnly"] = true
          tempJson["showNavigationButtons"] = "none"
          setPsychologistAssessment(tempJson)
        } else {
          setPsychologistAssessment(tempJson)
        }
      })
      .catch((err: any) => console.log(err?.message))

  }, [isReadOnly])

  useEffect(() => {
    if (recordId && selectedTab !== "Follow up visit") {
      // setIsLoading(true)
      getPsychologistDetails(recordId)
        .then((data: any) => {
          const res = data.assessment
          const progressData = data?.progressNotes
          setPsychologistData(progressData)
          setProgressNotes(progressData?.notes)
          setAssessmentData(res)
          setIsLoading(false)
        })
        .catch((err: any) => {
          console.log(err)
          setIsLoading(false)
        })
    }
  }, [selectedTab])

  const handlePsychologyAssessmentCompletion = (data: any) => {
    // setIsLoading(true)
    savePsychologyAssessment(
      data,
      {
        centerId,
        consultantId,
        patientId,
        appointmentId,
        recordId,
      }
    )
      .then((res: any) => {
        setIsLoading(false)
        setIsCompleted(true)
        setAssessmentData(res?.assessment)
      })
      .catch((err: any) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  const saveProgressNotes = () => {
    // setIsLoading(true)
    const temp = { ...psychologistData }
    temp["notes"] = progressNotes
    //API CALL
    saveAdditionalNotes(temp, appointmentId, recordId, "psychologist")
      .then((res: any) => {
        setIsLoading(false)
        setProgressNotesSaved(true)
      })
      .catch((err: any) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  return (
    <div className="psychology-page-container">
      {
        isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        )
      }
      <div className="patient-diagnosis">
        <div className="patient-smart-summary">
          <div className="tab-wrapper">
            {tabSection.map((tabname) => (
              <div
                className={`tab ${selectedTab === tabname ? "active" : ""}`}
                onClick={() => {
                  setSelectedTab(tabname)
                  if (tabname === "Smart Summary") {
                    fetchSmartSummary()
                  }
                }}
              >
                {tabname}
              </div>
            ))}
          </div>
          <div className="content-wrapper">
            {selectedTab === "Smart Summary" ? (
              <SummaryView
                patientDetail={patientInfo}
                smartSummaryDetails={smartSummaryDetails}
              />
            ) : selectedTab === "Follow up visit" ? (
              <ConsultantNotesView
                setResConsultantNoteData={setResConsultantNoteData}
                setIsConsultantNoteData={setIsConsultantNoteData}
                recordDetails={recordDetails}
                appointmentDetails={appointmentDetails}
                patientDetail={patientInfo}
                isReadOnly={isReadOnly}
                selectedIpdTab={selectedIpdTab}
                staffType={staffType}
                smartSummaryData={smartSummaryDetails}
              />
            ) : selectedTab === "Assessment" ? (
              <div>
                <span
                  className="print-button cursor-pointer"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Print
                    componentRef={componentRef}
                  />
                </span>
                <JSONRenderer
                  json={psychologistAssessment}
                  printJson={psychologistAssessmentPrint}
                  appointmentDate={appointmentDetails?.scheduleDate}
                  data={assessmentData}
                  printData={assessmentData}
                  printRef={componentRef}
                  patientData={{ patientInfo: patientInfo, vitalsData: vitalsData }}
                  showPatientDetails={true}
                  handleCompletion={handlePsychologyAssessmentCompletion}
                  origin={MocUserRole.PSYCHOLOGIST}
                  smartSummaryData={smartSummaryDetails}
                />
              </div>
            ) : selectedTab === "Progress" ? (
              <div className="advice mt-4">
                <div className="heading">Notes :</div>
                <div className="textarea">
                  <textarea
                    name=""
                    id=""
                    cols={50}
                    rows={5}
                    value={progressNotes}
                    onChange={(e) => {
                      setProgressNotes(e?.target.value)
                    }}
                    disabled={isReadOnly}
                    className={isReadOnly ? "disabled" : ""}
                  />
                </div>
                <div className="save-button mt-4">
                  {isReadOnly ? "" :
                    <Button text="Save" id="save" onClick={saveProgressNotes}></Button>
                  }
                </div>
              </div>
            ) : ("")
            }
          </div>
        </div>
        {
          isCompleted ? (
            <Toast
              textMessage="Assessment data saved successfully"
              onCloseText={"Close"}
              onClose={() => {
                setIsCompleted(false)
                const temp = { ...psychologistAssessment }
                setPsychologistAssessment({})
                setTimeout(() => {
                  setPsychologistAssessment(temp)
                }, 0)
              }}
              type="success"
            ></Toast>
          ) : resConsultantNoteData?.id && isConsultantNoteData ? (
            <Toast
              textMessage={` Follow Up Data added Successfully`}
              onCloseText={"Close"}
              onClose={() => setIsConsultantNoteData(false)}
              type="success"
            ></Toast>
          ) : progressNotesSaved ? (
            <Toast
              textMessage={` Progress notes saved Successfully`}
              onCloseText={"Close"}
              onClose={() => setProgressNotesSaved(false)}
              type="success"
            ></Toast>
          ) : (
            ""
          )
        }
      </div>
    </div>
  )
}

export default Psychologist
